import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import type {Optional} from '@yandex-delivery/types'
import {addQuery} from '@yandex-delivery/utils'

import type {NddClaimOffersInfoQuery, NddClaimOffersRequest, NddClaimOffersResponse} from 'src/shared/types'

import {appConfig} from '../../config'
import {fetch} from '../fetch'

export function fetchOffersInfoDeprecated(
  body: NddClaimOffersRequest,
  query: NddClaimOffersInfoQuery,
): Promise<Optional<NddClaimOffersResponse>> {
  return fetch<NddClaimOffersRequest, NddClaimOffersResponse, NddClaimOffersResponse>({
    url: addQuery(externalApiURL('platform/integration/v1/offers/info'), {...query, country: appConfig.countryCode}),
    method: 'post',
    body,
  })
}
